var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSendInvite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.183024 9.2252C0.42604 9.46821 0.807439 9.43108 1.25634 9.23195L9.24209 5.66772C9.45811 5.57322 9.63024 5.46859 9.745 5.35383C9.96439 5.13444 9.96439 4.86442 9.745 4.64503C9.63024 4.53028 9.45811 4.42564 9.24209 4.33114L1.21246 0.750039C0.820939 0.574528 0.429415 0.527275 0.183024 0.773665C-0.127495 1.08418 0.00413789 1.42508 0.230277 1.84698L1.49936 4.22313C1.64787 4.50665 1.77275 4.61803 2.05627 4.63153L9.21509 4.87117C9.29947 4.87455 9.34335 4.93193 9.3501 4.99943C9.3501 5.06694 9.30285 5.12094 9.21846 5.12431L2.05289 5.39095C1.78625 5.40108 1.66137 5.50571 1.49936 5.79598L0.253904 8.11475C0.0142639 8.5569 -0.13087 8.9113 0.183024 9.2252Z",
    fill: "#121114"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSendInvite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-send-invite.28f4ca8c575324608185f11e9bb768c6.svg";